module.exports = __webpack_public_path__ + "static/img/service_hightest.2de30a4f.png";